export default __webpack_public_path__ + "static/media/Productivity Solutions.3aedfa92.png";